import request from '@/utils/request'

// 查询保险订单列表
export function listInsurance(query) {
  return request({
    url: '/insuranceOrder/insuranceOrder/list',
    method: 'get',
    params: query
  })
}

// 查询保险订单分页
export function pageInsurance(query) {
  return request({
    url: '/insuranceOrder/insuranceOrder/page',
    method: 'get',
    params: query
  })
}

// 查询保险订单详细
export function getInsurance(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/detail',
    method: 'get',
    params: data
  })
}

// 查询投保详情
export function getUnderwritingDetail(params) {
  return request({
    url: '/insuranceOrder/insuranceOrder/underwritingDetail',
    method: 'get',
    params
  })
}

// 新增保险订单
export function addInsurance(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/add',
    method: 'post',
    data: data
  })
}

// 修改保险订单
export function updateInsurance(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/edit',
    method: 'post',
    data: data
  })
}

// 删除保险订单
export function delInsurance(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/delete',
    method: 'post',
    data: data
  })
}

// 手动重试投保
export function manualRetryInsurance(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/manualRetry',
    method: 'post',
    data
  })
}

// 手动取消投保
export function manualCancelInsurance(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/manualCancel',
    method: 'post',
    data
  })
}

// 回传保单
export function uploadInsurancePolicy(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/uploadPolicy',
    method: 'post',
    data
  })
}

// 人工更新投保状态
export function updateInsuranceManualStatus(data) {
  return request({
    url: '/insuranceOrder/insuranceOrder/manualStatus',
    method: 'post',
    data
  })
}
